<template>
  <div>
    <section>
      <div class="row">
        <div class="small-12 columns">
          <h2 class="section-sub-heading">Your details <help-icon message="We’ll use this info to estimate your retirement income and any Age Pension entitlement."></help-icon></h2>
        </div>
      </div>

      <personal-inputs></personal-inputs>

      <div class="row">
        <div class="small-12 medium-3 large-3 columns">
          <label>Include your partner? <help-icon message="Enter details for your partner in order to estimate your joint financial situation at retirement."></help-icon></label>
        </div>

        <div class="small-12 medium-9 large-7 columns text-right">
          <checkbox name="include-partner" :items="includePartners" :selected="IncludePartner" @change="setIncludePartner($event.value)"></checkbox>
        </div>

        <div class="show-for-large large-2 columns"></div>
      </div>

      <div class="spouse" v-show="IncludePartner.value">
        <hr />
        <div class="row">
          <div class="small-12 columns">
            <h2 class="section-sub-heading">Your partner's details <help-icon message="We’ll use this info to estimate your retirement income and any Age Pension entitlement."></help-icon></h2>
          </div>
        </div>

        <personal-inputs :modifier="partnerModifier"></personal-inputs>
      </div>
    </section>

    <div v-if="!hideNav">
      <hr />
      <div class="page-actions">
        <router-link class="button" :to="{name: 'about.super'}">Next &rarr;</router-link>

        <!-- <div class="skip">
          <router-link :to="{name: 'results'}">Skip to see results</router-link>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Constants } from '@/constants';
import bus from '@/events';

export default {
  props: ['hide-nav'],
  components: {
    PersonalInputs: require('../../inputs/PersonalInputs').default,
  },
  data() {
    return {
      partnerModifier: Constants.PARAMETER_PARTNER_SUFFIX,
      includePartners: {
        yes: {
          value: true,
          text: 'Yes',
        },
        no: {
          value: false,
          text: 'No',
        },
      },
    };
  },
  computed: {
    IncludePartner() {
      bus.$emit('resize');
      return this.$store.state.inputs.IncludePartner;
    },
  },
  methods: {
    ...mapActions([
      'actionIncludePartner',
    ]),
    setIncludePartner(value) {
      this.actionIncludePartner({ value });
    },
  },
};
</script>
